"use client";

import * as AvatarPrimitive from "@radix-ui/react-avatar";
import clsx from "clsx";
import type { ComponentPropsWithoutRef, ElementRef, ReactNode } from "react";
import { forwardRef } from "react";

import { avatarFallback, avatarImage } from "./avatar.css";
import type { AvatarVariantProps } from "./style";
import { avatar } from "./style";

export interface AvatarProps
  extends ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>,
    Omit<AvatarVariantProps, "borderStyle"> {
  children?: ReactNode;

  src: string;

  alt: string;
  fallback?: ReactNode;
}

/**
 * @deprecated 반응형 size가 필요할 때만 사용해 주세요. 그 외에는 \@daangn/carotene을 사용해주세요.
 */
const Avatar = forwardRef<ElementRef<typeof AvatarPrimitive.Root>, AvatarProps>(
  (props, ref) => {
    const { className, size = 48, src, alt, fallback, ...otherProps } = props;

    return (
      <AvatarPrimitive.Root
        ref={ref}
        className={clsx(avatar({ size }), className)}
        {...otherProps}
      >
        <AvatarPrimitive.Image
          src={src}
          alt={alt}
          className={avatarImage}
          {...otherProps}
        />
        {fallback ? (
          <AvatarPrimitive.Fallback className={avatarFallback} {...otherProps}>
            {fallback}
          </AvatarPrimitive.Fallback>
        ) : null}
      </AvatarPrimitive.Root>
    );
  },
);

Avatar.displayName = "Avatar";

export { Avatar };
